import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

export const PushNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // Initialize push notifications inside Router context
    usePushNotifications();
    
    return <>{children}</>;
};
